import React from "react";
import { Button, Toast } from "antd-mobile";
import { post } from "../../../utils/request";
import { href } from "../../../utils/util";
import api from "./api";
import { loadingToast } from "../loading";
import Cookies from "js-cookie";

import "./index.less";

class PapersUploadQY extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      YYZZ: "",
      YYZZUrl: "",
      regCode: "", // 统一社会信用代码
      customerName: "", //企业名称
      legalPerson: "", // 法定代表人
      defaultData: {
        orgIdentity: "1",
      },
    };
  }

  componentWillReceiveProps(prevProps) {
    if (
      this.state.defaultData.orgIdentity !==
        prevProps.defaultData.orgIdentity &&
      prevProps.defaultData.orgIdentity
    ) {
      this.setState({
        defaultData: prevProps.defaultData,
        YYZZ: "11111111",
        YYZZUrl: prevProps.defaultData.orgIdentity,
      });
    }
  }

  // 自动识别证件
  imgOCR = () => {
    const { urlOps } = this.props;
    let _this = this;
    loadingToast("营业执照OCR识别中...");
    post({
      url: api.h5.businessLicenseOCR + "?app_stoken=" + urlOps.app_stoken,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        image: this.state.YYZZUrl,
      },
    }).then(
      (res) => {
        // console.log('营业执照OCR识别', res)
        // Toast.info(res.msg,1);
        Toast.hide();
        if (res.result === "success") {
          _this.setState(
            {
              regCode: res.data.regCode,
              customerName: res.data.name,
              legalPerson: res.data.legalPerson,
            },
            () => {
              // _this.onCancel();
              _this.props.onCancel(
                res.data.legalPerson,
                res.data.name,
                this.state.YYZZUrl,
                res.data.regCode
              );
            }
          );
        } else {
          if (res.code == "-1") {
            Toast.info("登录失效", 1);
          } else {
            Toast.info("身份证OCR识别失败", 1);
          }
        }
      },
      (res) => {
        console.log("身份证OCR识别失败", res);
        Toast.info("身份证OCR识别失败", 1);
        if (res.code == "-1") {
          Toast.info("登录失效", 1);
        } else {
          Toast.info("身份证OCR识别失败", 1);
        }
      }
    );
  };

  imgUpload = (file, FN) => {
    const { urlOps } = this.props;
    loadingToast("图片上传中...");
    post({
      url: api.attachment + "?app_stoken=" + urlOps.app_stoken,
      headers: {
        "Content-Type": "multipart/form-data;",
      },
      data: {
        attachmenType: "IMGS_ALL",
        file: [file],
      },
    }).then(
      (res) => {
        if (res.result === "success" && res.data) {
          console.log(res.data);
          FN(res.data[0].attachmenturl);
        } else {
          if (res.code == "-1") {
            Toast.info("登录失效", 1);
          } else {
            Toast.info(res.msg, 1);
          }
        }
      },
      (res) => {
        if (res.code == "-1") {
          Toast.info("登录失效", 1);
        } else {
          Toast.info(res.msg, 1);
        }
      }
    );
  };

  imgChange = (type) => {
    let _this = this;
    var reader = new FileReader();
    var YYZZ = document.getElementById("YYZZ").files;

    reader.readAsDataURL(YYZZ[0]);
    reader.onload = function () {
      // console.log(this.result)
      _this.imgUpload(YYZZ[0], (img) => {
        _this.setState(
          {
            YYZZ: this.result.split("base64,")[1],
            YYZZUrl: img,
          },
          () => {
            Toast.hide();
            _this.imgOCR();
          }
        );
      });
    };
  };

  onCancel = () => {
    let { YYZZUrl } = this.state;
    var customerName = document.getElementById("customerName").value;
    var regCode = document.getElementById("regCode").value;
    var legalPerson = document.getElementById("legalPerson").value;
    this.props.onCancel(legalPerson, customerName, YYZZUrl, regCode);
  };

  render() {
    return (
      <div className="PapersUploadQYBox">
        <div className="uploadImgBox">
          <div className="uploadImg YYZZ">
            <input
              id="YYZZ"
              type="file"
              accept="image/*"
              onChange={() => {
                this.imgChange(1);
              }}
            />
            <label
              htmlFor="YYZZ"
              style={{
                backgroundImage: this.state.YYZZ
                  ? "url(" + this.state.YYZZUrl + ")"
                  : "",
                backgroundSize: "contain",
              }}
            ></label>
            <span>上传营业执照</span>
          </div>
        </div>
        <div className="toastText">
          *请上传彩色原件或加盖企业公章的复印件；非企业单位，请使用登记执照；图片仅限jpeg，jpg、png格式且大小不超过3M。
        </div>
        {this.state.YYZZ ? (
          <div className="numberBox">
            <p>以下信息自动识别，需仔细核对，如识别有误，请修正。</p>
            <div>
              <label htmlFor="customerName">
                <span>企业名称</span>
                <input
                  id="customerName"
                  value={this.props.customerName}
                  onChange={(e) => {
                    this.onCancel();
                  }}
                  onBlur={() => {
                    this.onCancel();
                  }}
                />
              </label>
              <label htmlFor="regCode">
                <span>统一社会信用代码/工商注册号</span>
                <input
                  id="regCode"
                  value={this.props.regCode}
                  onChange={(e) => {
                    this.onCancel();
                  }}
                  onBlur={() => {
                    this.onCancel();
                  }}
                />
              </label>
              <label htmlFor="legalPerson">
                <span>法定代表人姓名</span>
                <input
                  id="legalPerson"
                  value={this.props.legalPerson}
                  onChange={(e) => {
                    this.onCancel();
                  }}
                  onBlur={() => {
                    this.onCancel();
                  }}
                />
              </label>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default PapersUploadQY;



// WEBPACK FOOTER //
// ./src/identityVerification/modules/papersUpload_QY/index.js